import React from 'react'
import clsx from 'clsx'
import { Avatar as AvatarStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

type Props = {
  /** avatar image alt attribute value */
  alt?: string
  /** If true, will display a chatbot image */
  chatbot?: boolean
  /** If true, will display edit icon on hover  */
  editable?: boolean
  /**
   * The size of the avatar
   * @default medium
   */
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge'
  /** avatar image src attribute value */
  src?: string
  /** avatar image srcSet attribute value */
  srcSet?: string
  /** Optional status badge */
  status?: 'available' | 'away' | 'do-not-disturb' | 'offline'
}

export type AvatarProps = Props & CommonProps

const useStyles = createUseStyles(AvatarStyles, 'avatar')
const Avatar = ({ src, srcSet, alt, chatbot, editable, size = 'medium', status, className, ...rest }: AvatarProps) => {
  const classes = useStyles()
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes._none]: !src && !chatbot,
          [classes._chatbot]: chatbot === true,
          [classes._online]: status === 'available',
          [classes._away]: status === 'away',
          [classes._notDisturb]: status === 'do-not-disturb',
          [classes._offline]: status === 'offline',
          [classes._editable]: chatbot !== true && editable === true,
        },
        classes[`_${size}`],
        className,
      )}
      {...rest}
    >
      {src && !chatbot && <img className={classes.img} src={src} srcSet={srcSet} alt={alt} />}
    </div>
  )
}

export default Avatar
